import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as ClaimService from '../../Services/claim-service';
export function CustomDialog({ title, description, open, handleClose, objectDto, setObjectDto, setLoading, setValidate }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                "& .css-ypiqx9-MuiDialogContent-root": {
                    padding: "0 15px 15px 15px"
                }
            }}
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{
                    fontSize: "13px",
                    color: "#0087ff", textAlign: 'center',
                }}>
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={handleClose}>Trở lại</Button>
                <Button onClick={handleClose} autoFocus>Xem và tải đơn yêu cầu GQQL</Button> */}
                <a id="cancel" className="btn-danger btn" onClick={() => {
                    handleClose();
                    // ClaimService.HandleClose(objectDto, setObjectDto);
                }}> <span>Trở lại</span></a>
                <a id="confirm" className="btn-success btn" onClick={() => {
                    // ClaimService.HandleClose(objectDto, setObjectDto);
                    ClaimService.HandleSubmitRequestNoUpload(objectDto, setObjectDto, setLoading, setValidate);
                    handleClose();
                }}> <span>Xem và tải đơn yêu cầu GQQL</span></a>
            </DialogActions>
        </Dialog>
    )
}